import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function CoreWebVitalsPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>Core Web Vitals Check | OptiSiteSEO</title>
        <meta
          name="description"
          content="Check Core Web Vitals risks in your technical SEO and visibility report. See LCP and CLS risk hints with prioritized fixes."
        />
        <link rel="canonical" href={canonicalUrl("/core-web-vitals-check")} />
      </Helmet>

      <section className="card section">
        <p className="eyebrow">Core Web Vitals</p>
        <h1>Spot performance risks early</h1>
        <ul className="bullets">
          <li>Identify LCP and CLS risk signals</li>
          <li>Get recommendations that can support technical SEO, discoverability, and UX</li>
          <li>Pair with indexability and metadata fixes for a cleaner technical baseline</li>
        </ul>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo/index.html">
            View a sample
          </a>
        </div>
      </section>
    </div>
  );
}
